import { Typography } from '@euler/app/components/typography';
import { aiColors, tint } from '@euler/app/flows/ai-suite/theme';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { LucideIcon } from 'lucide-react-native';
import { memo } from 'react';
import { Pressable } from 'react-native';

/** A selectable option in a row of choices. */
export const BiChip = memo(
  ({
    label,
    selected,
    icon: Icon,
    disabled,
    onPress,
  }: {
    label: string;
    selected: boolean;
    icon?: LucideIcon;
    disabled?: boolean;
    onPress: () => void;
  }) => {
    const { rpx } = useResponsiveContext();
    const color = selected ? aiColors.primary : aiColors.foreground;
    return (
      <Pressable
        accessibilityRole="button"
        accessibilityState={{ selected, disabled: !!disabled }}
        disabled={disabled}
        onPress={onPress}
        style={({ pressed }) => ({
          flexDirection: 'row',
          alignItems: 'center',
          gap: rpx(4),
          paddingHorizontal: rpx(10),
          paddingVertical: rpx(6),
          borderRadius: rpx(16),
          borderWidth: 1,
          borderColor: selected ? aiColors.primary : aiColors.border,
          backgroundColor: selected
            ? tint(aiColors.primary, 0.08)
            : aiColors.card,
          opacity: disabled ? 0.45 : pressed ? 0.75 : 1,
        })}
      >
        {Icon ? <Icon size={13} color={color} /> : null}
        <Typography.Text
          family={selected ? 'medium' : 'regular'}
          size={rpx(12)}
          color={color}
        >
          {label}
        </Typography.Text>
      </Pressable>
    );
  },
);
